
import { call, takeEvery } from 'redux-saga/effects'

import { dispatchEventWithGeneric } from '../../core';

import createEventChangeLayerVisibility from '../events/changeLayerVisibility';
import createEventChangeView from '../events/changeView';

export const CLEAR = 'map/CLEAR';
export const CHANGE_VIEW = 'map/CHANGE_VIEW';
export const INIT_PROJECT = 'map/INIT_PROJECT';
export const SET_LAYER_VISIBILITY = 'map/SET_LAYER_VISIBILITY';
export const ADD_COMMAND = 'map/ADD_COMMAND';
export const REMOVE_COMMAND = 'map/REMOVE_COMMAND';
export const SET_TEMP_FEATURE = 'map/SET_TEMP_FEATURE';
export const SET_TOOLS_MODE = 'map/SET_TOOLS_MODE';

export default function getActions(dispatch) {
    return {
        addCommand: (name, params) => dispatch({
            type: ADD_COMMAND, name, params
        }),
        changeView: (center, zoom, rotation, resolution) => dispatch({
            type: CHANGE_VIEW, center, zoom, rotation, resolution
        }),
        setLayerVisibility: (id, visibility) => dispatch({
            type: SET_LAYER_VISIBILITY, id, visibility
        }),
        removeCommand: (id) => dispatch({
            type: REMOVE_COMMAND, id
        }),
        setTempFeature: (feature) => dispatch({
            type: SET_TEMP_FEATURE, feature
        }),
        setToolsMode: (toolsMode) => dispatch({
            type: SET_TOOLS_MODE, toolsMode
        })

    };
}

function* workChangeView(action) {
    yield call(
        dispatchEventWithGeneric,
        createEventChangeView(
            action.center, action.resolution, action.rotation, action.zoom
        )
    );
}

export function* watchChangeView() {
    yield takeEvery(CHANGE_VIEW, workChangeView);
}

function* workChangeLayerVisibility(action) {
    yield call(
        dispatchEventWithGeneric,
        createEventChangeLayerVisibility(
            action.id, action.visibility
        )
    );
}

export function* watchChangeLayerVisibility() {
    yield takeEvery(SET_LAYER_VISIBILITY, workChangeLayerVisibility);
}
